import React from 'react';
import classnames from 'classnames';
import Text from '../../../global/text/text';
import DefaultButton from '../../../global/default-button/default-button';
import { IUserGroupDTO } from '../../../../api/user-groups.dao';
import { editText } from '../../../../constants/common-labels.constants';

interface IProps extends IUserGroupDTO {
    handleEditGroupClick: (userGroupId: number) => void;
    isGroupSelected?: boolean;
}

const UserGroupsListItem = (props: IProps) => {
    const { name, description, userGroupId, handleEditGroupClick, isGroupSelected } = props;

    const groupEffectClasses = classnames({
        active: isGroupSelected,
        hoverable: !isGroupSelected
    });

    const onEdit = () => handleEditGroupClick(userGroupId);

    return (
        <tr className='role-item' onDoubleClick={onEdit}>
            <td className={groupEffectClasses}>
                <div className='role-item__column role-item__name'>
                    <div className='role-item__name-content'>
                        <Text className='role-item__text' message={name} withEllipsis />
                    </div>
                </div>
            </td>
            <td className={groupEffectClasses}>
                <div className='role-item__column role-item__description'>
                    <div className='role-item__description-content'>
                        <Text className='role-item__text' message={description} withEllipsis/>
                    </div>
                    <DefaultButton
                        className='visible-while-hovered'
                        modifier='slim'
                        text={editText()}
                        onClick={onEdit}
                    />
                </div>
            </td>
        </tr>
    );
};

export { UserGroupsListItem };
